/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowUpdateContentTypesMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  requiredContentTypes: Array<Types.ContentTypeEnum> | Types.ContentTypeEnum;
}>;

export type ISoftwareEscrowUpdateContentTypesMutation = {
  __typename?: 'Mutation';
  softwareEscrowUpdateContentTypes?: {
    __typename?: 'SoftwareEscrowUpdateContentTypesPayload';
    success: boolean;
    errors?: Array<string> | null;
    softwareEscrow?:
      | { __typename?: 'SaasEscrow'; id: string; requiredContentTypes: Array<Types.ContentTypeEnum> }
      | { __typename?: 'SoftwareEscrow'; id: string; requiredContentTypes: Array<Types.ContentTypeEnum> }
      | null;
  } | null;
};

export const SoftwareEscrowUpdateContentTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'softwareEscrowUpdateContentTypes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requiredContentTypes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContentTypeEnum' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'softwareEscrowUpdateContentTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'requiredContentTypes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'requiredContentTypes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softwareEscrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiredContentTypes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ISoftwareEscrowUpdateContentTypesMutation,
  ISoftwareEscrowUpdateContentTypesMutationVariables
>;
